import { computed, reactive } from 'vue';
import { clone } from 'ramda';
import { fetchUser } from '@/api/user/UserApi';

const userState = reactive({
  authUser: null,
  user: {
    roles: [],
    sites: []
  },
  isInitialized: false,
});

export const loadUser = async () => {
  if (!userState.isInitialized) {
    userState.user = await fetchUser(userState.authUser);
    userState.isInitialized = true;
  }
};


const useUserProvider = () => {
  const setAuthUser = id => {
    userState.authUser = id;
  };

  const getUser = () => {
    return userState.user;
  };

  return {
    loadUser,
    setAuthUser,
    getUser,
    currentUserSites: computed(() => userState.user.sites),
    currentUserRoles: computed(() => userState.user.roles),
    currentUser: computed(() => clone(userState.user)),
  };
};

export default useUserProvider;
